<button
  [ariaLabel]="ariaLabel()"
  [type]="buttonType()"
  class="button-accent"
  [ngClass]="{
    'button-clear': accentButtonStyle() === accentButtonStyleType.CLEAR,
    'button-soft': accentButtonStyle() === accentButtonStyleType.SOFT,
    'button-reverted': accentButtonStyle() === accentButtonStyleType.REVERTED,
    'full-width': fullWidth(),
    'font-size-large': fontSize() === 'large',
    'font-size-small': fontSize() === 'small',
    'height-xsmall': height() === 'xsmall',
    'height-small': height() === 'small',
    'height-medium': height() === 'medium',
    'height-medium-large': height() === 'mediumLarge',
    'height-large': height() === 'large',
    'height-xlarge': height() === 'xlarge',
    'bold': bold()
  }"
>
  <ng-content></ng-content>
</button>
